import app from '@/app';
import templateUrl from './result-item-button.html';

app.component('prResultItemButton', {
	templateUrl,
	bindings: {
		isDisabled: '<',
		onClick: '&',
		readonly: '<'
	}
});
